<!-- Datei-Uploads im Hintergrund (FileUploadQueueService). Unten rechts,
     unter dem CDK-Overlay — Dialoge decken die Anzeige ab. -->
<aside
  *ngIf="entries.length"
  class="upload-tray al-glass"
  role="status"
  aria-live="polite"
  [attr.aria-label]="'dialogs.fileUpload.tray.label' | translate"
>
  <div class="al-glass__body upload-tray__body">
    <header class="upload-tray__head">
      <nb-icon
        class="upload-tray__head-icon"
        [class.upload-tray__head-icon--ok]="!running && !failed"
        [class.upload-tray__head-icon--error]="!running && failed"
        [icon]="running ? 'upload-outline' : failed ? 'alert-triangle-outline' : 'checkmark-circle-2-outline'"
      ></nb-icon>
      <div class="upload-tray__title">
        <span *ngIf="running">
          {{ "dialogs.fileUpload.tray.running" | translate : { done: finished, total: total } }}
        </span>
        <span *ngIf="!running && !failed">
          {{ "dialogs.fileUpload.summary.allDone" | translate }}
        </span>
        <span *ngIf="!running && failed">
          {{ "dialogs.fileUpload.summary.partial" | translate : { done: succeeded, failed: failed } }}
        </span>
      </div>
      <button
        type="button"
        class="al-icon-button upload-tray__action"
        (click)="collapsed = !collapsed"
        [attr.aria-expanded]="!collapsed"
        [attr.aria-label]="(collapsed ? 'buttons.maximize' : 'buttons.minimize') | translate"
        [nbTooltip]="(collapsed ? 'buttons.maximize' : 'buttons.minimize') | translate"
      >
        <nb-icon [icon]="collapsed ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
      </button>
      <button
        *ngIf="!running"
        type="button"
        class="al-icon-button upload-tray__action"
        (click)="close()"
        [attr.aria-label]="'buttons.close' | translate"
        [nbTooltip]="'buttons.close' | translate"
      >
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </header>

    <nb-progress-bar
      *ngIf="running"
      class="upload-tray__progress"
      size="tiny"
      status="primary"
      [value]="progress"
    ></nb-progress-bar>

    <ng-container *ngIf="!collapsed">
      <ul class="upload-tray__list">
        <li
          class="upload-tray__item"
          *ngFor="let entry of entries; trackBy: trackEntry"
          [class.upload-tray__item--success]="entry.state === 'success'"
          [class.upload-tray__item--error]="entry.state === 'error'"
          [class.upload-tray__item--muted]="entry.state === 'cancelled' || entry.state === 'queued'"
        >
          <nb-icon class="upload-tray__item-icon" [icon]="iconOf(entry.state)"></nb-icon>
          <div class="upload-tray__item-main">
            <span class="upload-tray__item-name" [nbTooltip]="entry.name">{{ entry.name }}</span>
            <span class="upload-tray__item-note">
              <ng-container [ngSwitch]="entry.state">
                <ng-container *ngSwitchCase="'uploading'">{{ entry.progress | number : "1.0-0" }}%</ng-container>
                <ng-container *ngSwitchCase="'error'">{{ entry.error }}</ng-container>
                <ng-container *ngSwitchDefault>{{ "dialogs.fileUpload.tray.states." + entry.state | translate }}</ng-container>
              </ng-container>
            </span>
          </div>
        </li>
      </ul>

      <!-- Kontingent ist keine Panne, sondern eine Planfrage: Weg zu den
           Plänen bzw. zum Support statt einer roten Zeile. -->
      <section class="upload-tray__quota" *ngIf="quotaBreach">
        <p>
          {{
            (quotaBreach.kind === "files"
              ? "dialogs.fileUpload.quotaNotice.reasonFiles"
              : "dialogs.fileUpload.quotaNotice.reasonSize"
            ) | translate : { remaining: quotaBreach.remaining }
          }}
        </p>
        <div class="upload-tray__quota-actions">
          <button
            type="button"
            nbButton
            status="primary"
            size="small"
            *ngIf="canManagePlan"
            (click)="openPlans()"
          >
            {{ "dialogs.fileUpload.quotaNotice.showPlans" | translate }}
          </button>
          <a nbButton outline status="basic" size="small" [href]="supportMailHref">
            {{ "dialogs.fileUpload.quotaNotice.contactSupport" | translate }}
          </a>
        </div>
      </section>

      <footer class="upload-tray__foot" *ngIf="running">
        <span class="upload-tray__hint">{{ "dialogs.fileUpload.tray.backgroundHint" | translate }}</span>
        <button type="button" nbButton ghost size="tiny" status="basic" (click)="cancel()">
          {{ "buttons.cancel" | translate }}
        </button>
      </footer>
    </ng-container>
  </div>
</aside>
